/**
* Created by YYVZB on 2017/12/1.
*/
import Vue from 'vue'
import {getUserInfo, getUsersData, answerAjax,revive,hasAnsweredQuestions,randomSingleQuestion } from "@/api/ajax"
import api from '@/api/index'
import Config from '@/config/index'
import querystring from 'vux/src/tools/querystring/index.js'

import store from '@/store/index'
const Api = new api()
export const userGuide = (store, to, next) => {

let userInfoObj = Api.getStorage('wxUserInfo') || null


if (userInfoObj && userInfoObj.phone && !store.state.wxUserInfo.phone) {
Api.setVuexStorage(userInfoObj)
}

/*
* 授权并做回调缓存
* */
let toWxAuthThenCallBack = (name) => {




location.href = Config.wxAuth(name)
}

/*
* 查看用户今日是否已答题   true 已答题
* */
let userHasAnswered = (cb) => {
Vue.http.all([revive.hasUserReviceToday(),answerAjax.hasAnswered()]).then(Vue.http.spread((reviceRes,ifaRes)=>{
if(reviceRes.data.hasUse == '1'){

store.commit('SETREVICE',false)
}
cb(ifaRes.data.ifAnswered)
}))
}

/*
* 获取用户信息
* */

let getUserInfoFunc = (store, to, next) => {
if (userInfoObj && userInfoObj.phone && userInfoObj.id) {
if (to.name == 'play') {
userHasAnswered((ifAnswered) => {
if (ifAnswered == '0') {
next()
} else {
hasAnsweredQuestions().then(resp => {
let list = resp.data.list
for ( let i = 0; i < list.length; i++){
if (list[i].isRight == '0' || list[i].isRight == '2') { // 错
next({
name: 'wrong',
query: {
rightNum: i + 1,
wrongId: list[i].questionId
}
})
break;
}else if(list.length < 4 && !/0|2/.test(list[i])){
randomSingleQuestion().then(randomSingleRes=>{
next({
name: 'wrong',
query: {
rightNum: i + 1,
wrongId: randomSingleRes.data.question.id
}
})
});
break;
} else if (i >= 3) { //全对
next({
name: 'correct'
})
}
}
})
}
})
} else {
next()
}
} else { //如果没有缓存信息 走授权
getUsersData().then(res => {

let resp = res.data.data

if (resp) {

Vue.prototype.$sa.login(resp)

if (resp.userDataStatus) {
Api.setVuexStorage(resp)
if (to.name == 'play') {
userHasAnswered((ifAnswered) => {
if (ifAnswered == '0') {
next()
} else {
next({name: 'finshed'})
}
})
} else {

next()
}

} else {

Api.setVuexStorage(resp)

if (to.meta.needRegister) {

Api.setStorage('strLogin', {
url: location.href,
from: 'answer'
})
let registerUrl = '/html/newWechat.html#/register'
if(/sj-wx|doc\.jimijiayuan/.test(location.href)) {
registerUrl = '/html/clinical/index.html#/register'
}
Vue.prototype.$sa.setSaSession_href(to, registerUrl)
} else {
next()

}
}
} else {
Vue.$vux.toast.show({text: '即将为您授权', position: 'top', type: 'text', width: '5rem'})
toWxAuthThenCallBack(location.href)
}
}).catch(res => { //授权
Vue.$vux.toast.show({
text: '请您检查网络,3秒后为您重启页面',

type: 'cancel',
width: '5rem',
onHide() {
location.reload()
}
})
})
}
}
getUserInfoFunc(store, to, next)
}



// WEBPACK FOOTER //
// ./src/public/userGuide.js